<template>
	<div class="container">
		<div class="head" id="head"></div>
		<div class="leftTime">
			{{ nowTime }} 星期{{ week | getweek }}
		</div>
		<div class="rightBack" @click="returns()">
			<img src="../assets/back.png" alt="" srcset="">
		</div>
		<div style="width: 1920px;height: 100%;overflow: hidden;margin: 0 auto;position: relative;">
			<div class="contaniertwo" v-drag id="box" @mousewheel="scaleDom">
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=滨湖镇"
					target="_self">
					<div class="bingHu homeLogo">
						<el-popover placement="right" trigger="hover" popper-class="myPopper">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<div>
										<ul>
											<li>
												滨湖镇代表之家
											</li>
											<li>
												地址：滨湖派出所东邻、盛世红荷公司院内
											</li>
											<li>
												全国人大代表：_
											</li>
											<li>省人大代表: _</li>
											<li>枣庄市人大代表: 4人</li>
											<li>滕州市人大代表: 25人</li>
											<li>镇人大代表: 122人</li>
										</ul>
									</div>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=大坞镇"
					target="_self">
					<div class="daWu homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<div>
										<ul>
											<li>
												大坞镇代表之家
											</li>
											<li>
												地址: 旗晟建设集团
											</li>
											<li>
												全国人大代表: _
											</li>
											<li>省人大代表: _</li>
											<li>枣庄市人大代表: 3人</li>
											<li>滕州市人大代表: 22人</li>
											<li>镇人大代表: 105人</li>
										</ul>
									</div>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=界河镇"
					target="_self">
					<div class="jieHe homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											界河镇代表之家
										</li>
										<li>
											地址: 旗晟建设集团
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 3人</li>
										<li>滕州市人大代表: 18人</li>
										<li>镇人大代表: 94人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=龙阳镇"
					target="_self">
					<div class="longYang homeLogo">
						<el-popover placement="right" trigger="hover">
							<div class="boximg">

								<ul>
									<li>
										龙阳镇代表之家
									</li>
									<li>
										地址: 滕州市吉路尔轮胎有限公司
									</li>
									<li>
										全国人大代表: _
									</li>
									<li>省人大代表：_</li>
									<li>枣庄市人大代表: 3人</li>
									<li>滕州市人大代表: 17人</li>
									<li>镇人大代表: 92人</li>
								</ul>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=东郭镇"
					target="_self">
					<div class="dongGuo homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											东郭镇代表之家
										</li>
										<li>
											地址: 东郭镇便民服务中心
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 3人</li>
										<li>滕州市人大代表: 22人</li>
										<li>镇人大代表: 126人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=级索镇"
					target="_self">
					<div class="jingSuo homeLogo">
						<el-popover placement="right" trigger="hover" popper-class="myPopper">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											级索镇代表之家
										</li>
										<li>
											地址：级索镇政府二楼会议室
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 2人</li>
										<li>滕州市人大代表: 21人</li>
										<li>镇人大代表: 86人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=西岗镇"
					target="_self">
					<div class="xiGang homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											西岗镇代表之家
										</li>
										<li>
											地址: 西岗镇政府428室人大办公室
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 5人</li>
										<li>滕州市人大代表: 36人</li>
										<li>镇人大代表: 118人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=鲍沟镇"
					target="_self">
					<div class="baoGou homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">

									<ul>
										<li>
											鲍沟镇代表之家
										</li>
										<li>
											地址: 鲍沟镇驻地商业街
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表： _</li>
										<li>枣庄市人大代表: 4人</li>
										<li>滕州市人大代表: 19人</li>
										<li>镇人大代表: 102人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=洪绪镇"
					target="_self">
					<div class="hongXu homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											洪绪镇代表之家
										</li>
										<li>
											地址：洪绪镇广大美铭生态颐园四楼
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 3人</li>
										<li>滕州市人大代表: 13人</li>
										<li>镇人大代表: 67人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=南沙河镇"
					target="_self">
					<div class="nanShaHe homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">

									<ul>
										<li>
											南沙河镇代表之家
										</li>
										<li>
											地址：上徐村
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 3人</li>
										<li>滕州市人大代表: 13人</li>
										<li>镇人大代表: 78人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=木石镇"
					target="_self">
					<div class="muShi homeLogo">
						<el-popover placement="right" trigger="hover" popper-class="myPopper">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											木石镇代表之家
										</li>
										<li>
											地址：木石镇办公楼616
										</li>
										<li>
											全国人大代表: 1人
										</li>
										<li>省人大代表: 1人</li>
										<li>枣庄市人大代表: 5人</li>
										<li>滕州市人大代表: 19人</li>
										<li>镇人大代表: 76人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=羊庄镇"
					target="_self">
					<div class="yangZhuang homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											拟选
										</li>
										<li>
											地址: 拟建
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 3人</li>
										<li>滕州市人大代表: 21人</li>
										<li>镇人大代表: 99人</li>
									</ul>
								</div>

							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=张汪镇"
					target="_self">
					<div class="zhangWang homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">

									<ul>
										<li>
											张汪镇代表之家
										</li>
										<li>
											地址: 张汪镇便民服务中心党建室
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 3人</li>
										<li>滕州市人大代表: 21人</li>
										<li>镇人大代表: 99人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=柴胡店镇"
					target="_self">
					<div class="chaiHuDian homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											柴胡店镇代表之家
										</li>
										<li>
											地址: 旗晟建设集团
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 2人</li>
										<li>滕州市人大代表: 13人</li>
										<li>镇人大代表: 23人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=官桥镇"
					target="_self">
					<div class="guanQiao homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">

									<ul>
										<li>
											官桥镇代表之家
										</li>
										<li>
											地址: 官桥镇政府人大办公室
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 4人</li>
										<li>滕州市人大代表: 21人</li>
										<li>镇人大代表: 91人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=姜屯镇"
					target="_self">
					<div class="jiangTun homeLogo">
						<el-popover placement="right" trigger="hover" popper-class="myPopper">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											姜屯镇代表之家
										</li>
										<li>
											地址：山东鑫典精密铸造有限公司
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 4人</li>
										<li>滕州市人大代表: 21人</li>
										<li>镇人大代表: 104人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=荆河街道"
					target="_self">
					<div class="jingHe1 homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">

									<ul>
										<li>
											荆河街道代表之家
										</li>
										<li>
											地址: 荆河街道大同天下丹香苑党群服务中心
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 1人</li>
										<li>滕州市人大代表: 1人</li>
										<li>镇人大代表：21人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=荆河街道"
					target="_self">
					<div class="jingHe2 homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											荆河街道代表之家
										</li>
										<li>
											地址: 荆河街道大同天下丹香苑党群服务中心
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 1人</li>
										<li>滕州市人大代表: 1人</li>
										<li>镇人大代表：21人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=北辛街道"
					target="_self">
					<div class="beiXin homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="beiXinImg">
									<ul>
										<li>
											北辛街道代表之家
										</li>
										<li>
											地址: 大同北路与通盛路交叉口东北方向
											<div style="text-indet:2em">（大同社区党群服务中心内）</div>
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 1人</li>
										<li>滕州市人大代表: 7人</li>
										<li>镇人大代表: 23人</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<div class="beiXinZong masterStation">
					<el-popover placement="right" trigger="hover" popper-class="myPopper">
						<div style="width:100% ;height:200px;">
							<div class="boximg">
								<div style="padding-bottom:10px;">
									<ul>
										<li>
											滕州市联络总站
										</li>
										<li>
											负责人: 魏朝廷
										</li>
										<li>
											地址: 北辛中路翔宇国际A座三楼
										</li>
										<li>
											代表人数: 442人
										</li>
										<li>
											全国人大代表: 2人
										</li>
										<li>省人大代表: 6人</li>
										<li>枣庄市人大代表: 121人</li>
										<li>滕州市人大代表: 444人</li>
									</ul>
								</div>
							</div>
						</div>
						<div style="width: 100%;height: 100%;" slot="reference" />
					</el-popover>
				</div>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=龙泉街道"
					target="_self">
					<div class="longQuan1 homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											龙泉街道代表之家
										</li>
										<li>
											地址: 龙泉街道龙泉观察广场
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: _</li>
										<li>滕州市人大代表: _</li>
										<li>镇人大代表：_</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=龙泉街道"
					target="_self">
					<div class="longQuan2 homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											龙泉街道代表之家
										</li>
										<li>
											地址: 滕州市安居小区
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: _</li>
										<li>滕州市人大代表: _</li>
										<li>镇人大代表：_</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=东沙河街道"
					target="_self">
					<div class="dongShaHe homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											东沙河街道人大代表之家
										</li>
										<li>
											地址: 东沙河街道六合社区党群服务中心
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 3人</li>
										<li>滕州市人大代表: 16人</li>
										<li>镇人大代表：_</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>
				<a href="https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-3C866TC1OZP9U0ZF8H1FWAAI8OTG25Z8PO7GL8?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&name=善南街道"
					target="_self">
					<div class="shanNan homeLogo">
						<el-popover placement="right" trigger="hover">
							<div style="width:100% ;height:200px;">
								<div class="boximg">
									<ul>
										<li>
											善南街道代表之家
										</li>
										<li>
											地址: 清华园小区
										</li>
										<li>
											全国人大代表: _
										</li>
										<li>省人大代表: _</li>
										<li>枣庄市人大代表: 1人</li>
										<li>滕州市人大代表: 11人</li>
										<li>镇人大代表：_</li>
									</ul>
								</div>
							</div>
							<div style="width: 100%;height: 100%;" slot="reference" />
						</el-popover>
					</div>
				</a>

				<div class="jingKai  squre">
					<el-popover placement="right" trigger="hover" popper-class="myPopper">
						<div style="width:100% ;height:200px;">
							<div class="boximg">
								<div>
									<ul>
										<li>
											经开区联络站
										</li>
										<li>
											负责人: 徐夫成
										</li>
										<li>
											代表人数: 38人
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div style="width: 100%;height: 100%;" slot="reference" />
					</el-popover>
				</div>

			</div>
		</div>
        <div class="mapsimg" />
		<div class="mapcss">
			<div class="tuli" v-for="item,index in heading" :key="index">
				<el-row>
					<el-col :span="4">
						<div style="display: flex;justify-content: center;margin-top: 16px;">
							<el-image style="width: 28px; height: 30px" :src="item.img"></el-image>
						</div>
					</el-col>
					<el-col :span="11">
						<div style="font-size: 20px;color: #fff;width: 100%;line-height:60px;text-align:left;">
							{{item.tit}}
						</div>
					</el-col>
					<el-col :span="9">
						<div style="height: 34px;">
							<div style="text-align: center;line-height: 60px;display: flex;">
								<div style="color: #fff;">(</div>
								<div class="textsunzi">{{item.siz}}
								</div>
								<div style="color: #fff;">)</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import axios from 'axios';
	import {
		getport
	} from '@/api/api'
	// 引入这个json 文件
	export default {
		data() {
			return {
				nowTime: '',
				week: '',
				heading: [{
					img: require('@/assets/zz.png'),
					tit: '代表联络总站',
					siz: '1个'
				}, {
					img: require('@/assets/whgc.png'),
					tit: '宪法文化广场',
					siz: '1个'
				}, {
					img: require('@/assets/zj.png'),
					tit: '代表之家',
					siz: '23个'
				}, {
					img: require('@/assets/llz.png'),
					tit: '代表联络站',
					siz: '7个'
				}, {
					img: require('@/assets/lxd.png'),
					tit: '代表联系点',
					siz: '177个'
				}, {
					img: require('@/assets/gzs.png'),
					tit: '代表工作室',
					siz: '9个'
				}]
			}
		},
		// 自定义指令 —— 拖动div
		directives: {
		    drag(el) {
		        let oDiv = el // 当前元素
		        // let self = this // 上下文
		        // 禁止选择网页上的文字
		        document.onselectstart = function () {
		            return false
		        }
		        oDiv.onmousedown = function (e) {
		            // 鼠标按下，计算当前元素距离可视区的距离
		            let disX = e.clientX - oDiv.offsetLeft
		            let disY = e.clientY - oDiv.offsetTop
		            document.onmousemove = function (e) {
		                // 通过事件委托，计算移动的距离
		                let l = e.clientX - disX
		                let t = e.clientY - disY
		                // 移动当前元素
		                oDiv.style.left = l + 'px'
		                oDiv.style.top = t + 'px'
		            }
		            document.onmouseup = function (e) {
		                document.onmousemove = null
		                document.onmouseup = null
		            }
		            // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
		            return false
		        }
		    }
		},
		methods: {
			// 返回主页
			returns() {
				this.$router.replace({
					path: '/'
				});
			},
			// 用户缩放
			scaleDom() {
				let div = document.getElementById("box");
				let headDiv = document.getElementById("head");
				let scale = parseFloat((div.style.transform || `scale(0.9)`).replace(/[^0-9.]/gi, ''))
				let size = event.wheelDelta / 1200;
				scale += size;
				if (scale >= 0.5) {
					div.style.transform = `scale(${scale})`;
				}
			},
			// 获取当前时间
			getCurrentTime() {
				this.nowTime = moment().format('YYYY年MM月DD日')
				this.week = moment().format('E')
			},
			getmapsiz() {
				let path = '?id=12'
				getport('', path).then(res => {
					this.heading[0].tit = res.data[0].tit
					this.heading[0].siz = res.data[0].siz + '个'
					this.heading[1].tit = res.data[1].tit
					this.heading[1].siz = res.data[1].siz + '个'
					this.heading[2].tit = res.data[2].tit
					this.heading[2].siz = res.data[2].siz + '个'
					this.heading[3].tit = res.data[3].tit
					this.heading[3].siz = res.data[3].siz + '个'
					this.heading[4].tit = res.data[4].tit
					this.heading[4].siz = res.data[4].siz + '个'
					this.heading[5].tit = res.data[5].tit
					this.heading[5].siz = res.data[5].siz + '个'
				})
			},
		},
		mounted() {
			this.getCurrentTime();
		},
		created() {
			this.getmapsiz()
		},
		filters: {
			getweek(e) {
				var week = ['一', '二', '三', '四', '五', '六', '日']
				return week[e - 1]
			},
		},
	}
</script>

<style scoped>
	body {
		background-color: #000128;
	}

	ul,
	ol {
		list-style: none;
		margin: 0px;
		padding: 4px 2px;
		color: #fefeff;
		font-weight: 400;
		font-size: 16px;
	}

	ul li:first-child {
		color: #ffffff;
		font-size: 32px;
		font-weight: bold;
		padding-bottom: 20px;
	}

	.container {
		width: 1920px;
		height: 1080px;
		margin: 0 auto;
		overflow: hidden;
		background: url('../assets/boxBg.png') no-repeat center;
	}

	.head {
		width: 1920px;
		height: 124px;
		background: url('../assets/headbg.png') no-repeat center;
		position: relative;
		margin-top: 40px;
	}

	.leftTime {
		position: absolute;
		margin-left: 100px;
		margin-top: -45px;
		color: #fff;
		font-size: 20px;
	}

	.rightBack {
		position: absolute;
		margin-top: -45px;
		right: 280px;
	}

	.textsunzi {
		width: 100%;
		font-size: 26px;
		font-weight: 600;
		background-image: -webkit-linear-gradient(bottom, #FFC500, #FFC500, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	#box {
		width: 1300px;
		height: 100%;
		background: url('../assets/tzbg.png') no-repeat center;
		background-size: 125% 100%;
		padding: 0 0 0 0;
		-webkit-transform: scale(0.9);
		transform: scale(0.9);
		/* display: inline-block; */
		margin: 0 auto;
		margin-top: -120px;
		overflow: hidden;
	}

	.boximg {
		width: 400px;
		height: 100%;
		padding: 40px 0px 80px 80px;
		line-height: 30px;
		border-radius: 4px;
		color: #fff;
		font-size: 16px;
		background: url('../assets/透明框.png') no-repeat center;
		background-size: 100% 100%;
	}

	.beiXinImg {
		width: 400px;
		height: 100%;
		padding: 40px 20px 100px 80px;
		line-height: 30px;
		border-radius: 4px;
		color: #fff;
		font-size: 16px;
		background: url('../assets/透明框.png') no-repeat center;
		background-size: 100% 100%;
	}

	.homeLogo {
		background-image: url('../assets/三角形.png');
		width: 40px;
		height: 30px;
	}

	.masterStation {
		background-image: url('../assets/联络总站.png');
		background-size: 100% 100%;
		width: 40px;
		height: 50px;
	}

	.squre {
		background-image: url('../assets/方块.png');
		background-size: 100% 100%;
		width: 26px;
		height: 26px;
	}

	.jingKai {
		margin-left: 760px;
		margin-top: 580px;
		position: absolute;
	}

	.bingHu {
		margin-left: 270px;
		margin-top: 370px;
		position: absolute;
	}

	.contaniertwo {
		position: absolute;
		width: 1920px;
		height: 640px;
		border: 1px solid transparent;
		background: url('../assets/map.png') no-repeat center;
		background-size: 100% 100%;
		transform: scale(1);
		left: 0;
		right: 0;
	}

	.daWu {
		margin-left: 410px;
		margin-top: 410px;
		position: absolute;
	}

	.jieHe {
		margin-left: 497px;
		margin-top: 281px;
		position: absolute;
	}

	.longYang {
		margin-left: 730px;
		margin-top: 270px;
		position: absolute;
	}

	.dongGuo {
		margin-left: 858px;
		margin-top: 282px;
		position: absolute;
	}

	.jingSuo {
		margin-left: 444px;
		margin-top: 612px;
		position: absolute;
	}

	.xiGang {
		margin-left: 446px;
		margin-top: 712px;
		position: absolute;
	}

	.baoGou {
		margin-left: 680px;
		margin-top: 664px;
		position: absolute;
	}

	.hongXu {
		margin-left: 679px;
		margin-top: 575px;
		position: absolute;
	}

	.nanShaHe {
		margin-left: 780px;
		margin-top: 668px;
		position: absolute;
	}

	.muShi {
		margin-left: 888px;
		margin-top: 694px;
		position: absolute;
	}

	.guanQiao {
		margin-left: 791px;
		margin-top: 814px;
		position: absolute;
	}

	.zhangWang {
		margin-left: 722px;
		margin-top: 824px;
		position: absolute;
	}

	.chaiHuDian {
		margin-left: 846px;
		margin-top: 879px;
		position: absolute;
	}

	.yangZhuang {
		margin-left: 968px;
		margin-top: 749px;
		position: absolute;
	}

	.jiangTun {
		margin-left: 590px;
		margin-top: 473px;
		position: absolute;
	}

	.jingHe1 {
		margin-left: 630px;
		margin-top: 433px;
		position: absolute;
	}

	.jingHe2 {
		margin-left: 695px;
		margin-top: 524px;
		position: absolute;
	}

	.beiXin {
		margin-left: 673px;
		margin-top: 436px;
		position: absolute;
	}

	.beiXinZong {
		margin-left: 702px;
		margin-top: 420px;
		position: absolute;
	}

	.longQuan1 {
		margin-left: 736px;
		margin-top: 456px;
		position: absolute;
	}

	.longQuan2 {
		margin-left: 724px;
		margin-top: 484px;
		position: absolute;
	}

	.dongShaHe {
		margin-top: 492px;
		position: absolute;
		left: 872px;
	}

	.shanNan {
		margin-left: 733px;
		margin-top: 555px;
		position: absolute;
	}

	.el-popover {
		position: absolute;
		background: transparent;
		min-width: 100px;
		border-radius: 4px;
		z-index: 2000;
		color: #606266;
		line-height: 1.4;
		text-align: justify;
		font-size: 14px;
		word-break: break-all;
		transform-origin: left center;
		z-index: 2005;
		border: unset;
		margin-left: 0;
	}

	.mapcss {
		width: 280px;
		bottom: 70px;
		z-index: 999;
		position: absolute;
		margin-left: 50px;
		/* border: 1px solid red; */
	}

	.tuli {
		width: 100%;
		height: 64px;
		background: url('../assets/tuli.png') no-repeat center;
		background-size: 100% 90%;
		/* border: 1px solid red; */
	}
	.mapsimg {
		width: 580px;
		height: 100px;
		position: absolute;
		background: url('../assets/quanguocheng.png') no-repeat center;
		background-size: 100% 100%;
		/* border: 1px solid red; */
		margin-top: -1050px;
		margin-left: 40px;
	}
	.el-picker-panel,
	.el-popover,
	.el-select-dropdown,
	.el-table-filter,
	.el-time-panel {
		-webkit-box-shadow: none;
	}
</style>